import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging';
import { RegistrationModel } from './registration.model';
import { EfaactDataService } from '../efaact.data-service';
import { isDateSelectionValid } from '@fullcalendar/core/validation';

export const entityName = 'Registration';
@Injectable({ providedIn: 'root' })
export class RegistrationDataService extends EfaactDataService<RegistrationModel> {
    mapItems(item: RegistrationModel): RegistrationModel {
        return { ...item, id: item.CustomerId };
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}
